import ExtendServicePlanComponent from './ServicePlanExtendComponent';

export default ExtendServicePlanComponent;
